import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import RolePermissions from '../rolePermissions/RolePermissions';
var RolePermissionsEditor = function (_a) {
    var role = _a.role;
    var handlePermissionPressed = useCallback(function (permissionLevel, permissionFlag) {
        role.beginEditing();
        role.togglePermissionFlag(permissionLevel, permissionFlag);
        role.pauseEditing();
    }, [role]);
    return (React.createElement(RolePermissions, { role: role, onPermissionPressed: handlePermissionPressed }));
};
export default observer(RolePermissionsEditor);
//# sourceMappingURL=RolePermissionsEditor.js.map